import { render } from "./CustomSortControl.vue?vue&type=template&id=2147fa80"
import script from "./CustomSortControl.vue?vue&type=script&lang=js"
export * from "./CustomSortControl.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__